import styled from "styled-components";
import Globais from "../../css/Globais";

// ----------- Imagens Padrões -----------

import calendario from "../../images/calendario.jpg";
import mapa from "../../images/mapaApartamentos.jpg";
import alimentacao from "../../images/alimentacao.jpg";
import autorizacao from "../../images/autorizacao.jpg";
import contato from "../../images/contato.jpg";

export const images = {
  calendario,
  mapa,
  alimentacao,
  autorizacao,
  contato,
};
//-----------------------------------------------------------------------------

// ----------- Styles Index -----------
export const Container = styled.div`
  width: 100%;
  min-height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f0f4f7;
`;

export const ContainerTitulo = styled.div`
  width: 100%;
  height: 10vh;
  display: flex;
  justify-content: center;
`;
export const TituloForm = styled.h2`
  width: 10rem;
  text-align: center;
  color: ${Globais.CorAzulBackGround};
  font-size: 1.8rem;
  width: 80%;
  @media (min-width: 900px) {
    font-size: 2.1rem;
  }
  @media (min-width: 1276px) {
    font-size: 2.5rem;
  }
`;
//-----------------------------------------------------------------------------

// ---------- Styles Card -----------

export const ContainerCard = styled.div`
  width: 100%;
  min-height: auto;
  margin-top: 3%;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  justify-content: space-around;
  gap: 20px;
  background-color: #f0f4f7;
  padding: 10px;
  box-sizing: border-box;

  @media (maxwidth: 768px) {
    // Para tablets
    justify-content: center;
    gap: 15px;
  }

  @media (maxwidth: 480px) {
    // Para celulares
    flex-direction: column; // Alinha os cards em coluna para ocupar 100% da largura
    align-items: center;
    gap: 10px;
  }
`;

export const CardStyle = {
  width: "270px",
  flexGrow: 0,
  flexShrink: 1,
  marginBottom: 20,

  "@media (maxWidth: 768px)": {
    // Ajusta o tamanho dos cards para tablets
    width: "200px",
  },

  "@media (maxWidth: 480px)": {
    // Ajusta para ocupar 100% da largura em celulares
    width: "100%",
  },
};
//-----------------------------------------------------------------------------//-----------------------------------------------------------------------------
// ---------- Styles Fallback -----------

export const ContainerFallback = styled.div`
  margin-top: 1%;
  width: 100vw;
  height: 30vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: #f0f4f7;
  padding: 20px;
`;
export const MessageFallback = styled.p`
  font-size: 32px;
  font-weight: bold;
  color: #003644; // cor sutilmente mais escura para contraste
  margin: 0; // remove margem para centralização mais limpa
`;
//-----------------------------------------------------------------------------//-----------------------------------------------------------------------------

// ---------- Styles Modal -----------
export const Title = styled.h1`
  font-size: 20px; // Aumente o tamanho da fonte para destaque
  font-weight: bold;
  color: #003644;
  margin: 0;
  text-align: center; // Centraliza o título
`;

export const SubTitle = styled.h2`
  // Use h2 para sub-títulos
  font-size: 16px; // Aumente um pouco o tamanho
  font-weight: semi-bold; // Pode usar semi-bold para um destaque
  color: #005f6b; // Alterar a cor para um tom mais suave
  margin: 10px 0; // Margem superior e inferior para espaçamento
`;

export const ContainerBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center; // Centraliza verticalmente
  margin: 10px 0; // Margem superior e inferior
  padding: 8px; // Adiciona preenchimento para um visual mais espaçado
  border-bottom: 1px solid #d1d1d1; // Linha de separação entre os itens
`;

export const ContainerText = styled.div`
  font-size: 14px; // Aumentar um pouco o tamanho da fonte
  color: #858986;
  margin-left: 15px; // Mantém a margem para o texto
  text-decoration: none; // Remove o sublinhado dos links
`;
export {};
